import * as React from 'react';
import { cn } from '@/lib/utils';
import { AppPageLayout } from '@/modules/shared/components/ui/AppPageLayout';
import { useRequireSuperAdminLayout } from './SuperAdminLayoutContext';

interface SuperAdminPageContainerProps {
  children: React.ReactNode;
  pageName?: string;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'full';
  noPadding?: boolean;
}

export function SuperAdminPageContainer({
  children,
  pageName = 'SuperAdmin page',
  className,
  maxWidth = 'xl',
  noPadding = false,
}: SuperAdminPageContainerProps) {
  useRequireSuperAdminLayout(pageName);

  return (
    <AppPageLayout maxWidth={maxWidth} noPadding={noPadding}>
      <div className={cn('space-y-3', className)}>{children}</div>
    </AppPageLayout>
  );
}

export default SuperAdminPageContainer;